import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  logoContainer: {
    margin: '36px',
  },
  logo: {
    height: '36px',
    width: '100px',
  },
  contentContainer: {
    maxWidth: '478px',
    margin: '0 70px 0 172px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 36px 0 36px',
    },
  },
  titleGap: {
    marginTop: '6px',
  },
  linkNavigation: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
  linkNavigationTitle: {
    color: theme.colors.text[900],
  },
  linkNavigationText: {
    color: theme.colors.primary.main,
  },
}));
